import React, { PropsWithChildren } from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import { Header, HeaderButtons } from '../components/header/header';

const makeStyles = (theme: Theme) => ({
  mainBox: {
    pt: '50px',
    pr: '10px', //120px
    pb: '20px', //100px
    pl: '10px', //120px
    flex: 1,

    [theme.breakpoints.down('sm')]: {
      pt: 0,
    },
  },
  wrapperBox: {
    display: 'flex',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  navbarBox: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
});

interface Props {
  buttons?: HeaderButtons[];
}

export function AppMain({
  buttons,
  children,
}: PropsWithChildren<Props>): JSX.Element {
  const theme = useTheme();
  const styles = makeStyles(theme);

  return (
    <Box sx={styles.wrapperBox}>
      <Box sx={styles.navbarBox}>
        <Header buttons={buttons} />
      </Box>
      <Box sx={styles.mainBox}>{children}</Box>
    </Box>
  );
}
